/* eslint-disable */

devex = devex || {};
devex.urls = devex.urls || {};

/**
 * Service to handle browser URL parameters. Singleton object, use `getInstance`
 * to retrieve instance. Then use `addParam` to register parameters and trigger
 * `updateUrl` to refresh the URL.
 *
 * @type {{getInstance}}
 */
devex.urls.BrowserUrl = (function() {
  var instance,
      definedParams = [],
      afterParametersChangedCallbacks = [];

  function init() {
    /**
     * Return a parameter's value as it is defined in the URL. If the parameter
     * is not present in the URL, return `undefined`.
     *
     * @param {object} paramObject
     * @param {object} urlObject
     * @returns {*}
     */
    function extractValueFromUrl(paramObject, urlObject) {
      // Our params can always only contain one value
      var key = Object.keys(paramObject)[0];

      // TODO fix bug when paramObject key is similar to `sorting[order]`
      // urlObject will then be {sorting: {order: ...}} Those params should
      // return their current value instead of returning undefined
      if (urlObject[key] === undefined) {
        return undefined;
      }

      if (typeof paramObject[key] !== 'function') {
        return extractValueFromUrl(paramObject[key], urlObject[key]);
      } else {
        return urlObject[key];
      }
    }

    /**
     * Generate a unique identifier for the param based on its keys
     *
     * @param {object} paramObject
     * @returns {string}
     */
    function generateParamIdentifier(paramObject) {
      var key = Object.keys(paramObject)[0];
      if (Object.prototype.toString.call(paramObject[key]) == '[object Object]') {
        return key + '/' + generateParamIdentifier(paramObject[key]);
      } else {
        return key;
      }
    }

    /**
     * Given a parameter object with its nested value getter function, this
     * method will evaluate the getter and return the full param value with
     * its value
     *
     * @param {object} paramObject Will be passed internally in the recursion
     */
    function generateParamValue(paramObject) {
      return JSON.parse(
        JSON.stringify(
          paramObject,
          function (key, value) {
            return (typeof value === 'function') ? value() : value;
          }
        )
      );
    }

    /**
     * Invoke the defined callbacks on params which have changed in the last URL
     * update.
     *
     * @returns {string[]} Array of param ids of params which have changed
     */
    function callChangedParamCallbacks() {
      var changedParamIdentifiers = [];

      definedParams.forEach(function (definedParam) {
        var urlParam = definedParam.getUrlValueOrDefault();
        if (!_.isEqual(urlParam, definedParam.getValue())) {
          definedParam.callbackOnChange(urlParam);
          changedParamIdentifiers.push(definedParam.identifier);
        }
      });

      return changedParamIdentifiers;
    }

    /**
     * Invoke afterParametersChanged-callbacks which are registered on
     * parameters which have changed in the last URL update (and are therefore
     * passed as `changedParamIdentifiers`).
     *
     * @param {string[]} changedParamIdentifiers Array of param ids which have
     *                                           changed
     */
    function callAfterParametersChangedCallbacks(changedParamIdentifiers) {
      var changesInAnyParam;
      afterParametersChangedCallbacks.forEach(function(changeCallback) {
        changesInAnyParam =
          changeCallback.parameterIdentifiers.some(function (paramIdentifier) {
            return changedParamIdentifiers.indexOf(paramIdentifier) >= 0;
          });

        if (changesInAnyParam) {
          changeCallback.callback();
        }
      });
    }

    /**
     * Register to URL changes and trigger callbacks
     */
    devex.urls.on('stateChange', function() {
      var changedParamIdentifiers = callChangedParamCallbacks();
      callAfterParametersChangedCallbacks(changedParamIdentifiers);
    });

    /**
     * Register a callback which will be triggered when at least one of the
     * parameters identified by `parametersIdentifiers` has been changed.
     *
     * @param {string[]} parameterIdentifiers
     * @param {function} callback
     * @returns {boolean} True if callback was successfully registered
     */
    function registerAfterParamsChangedCallback(parameterIdentifiers, callback) {
      afterParametersChangedCallbacks.push(
        {
          parameterIdentifiers: parameterIdentifiers,
          callback: callback
        }
      );
      return true;
    }

    return {
      /**
       * Return this internal list of defined params. Mainly used for testing.
       *
       * @returns {Array}
       */
      getDefinedParams: function () {
        return definedParams;
      },
      /**
       * Register a URL parameter and set it to the current value in the URL
       *
       * Usage:
       * ```js
       * var myFilterValue = 123;
       * browserUrl.addParam(
       *   {filter: { my_filter: function() { return this.myFilterValue; }}},
       *   null,
       *   function(newValue) { this.myFilterValue = newValue; }
       * )
       * ```
       *
       * @param {object} param - Parameter, optionally nested, with leaf node
       *                         being the getter function for the value
       * @param {=function} onChange - If provided, this method will be called
       *                               with the new value when the parameter in
       *                               the URL changes
       * @param {=object} defaultValue - If the parameter has this value, it
       *                                 will not be included in the URL
       *                                 (default: null)
       * @returns {string} identifier of the defined param, based on its keys
       */
      addParam: function (param, onChange, defaultValue) {
        defaultValue = _.clone(defaultValue);

        var paramDefinition = {
          param: param,
          identifier: generateParamIdentifier(param),
          getValue: devex.util.getFirstLeafNode(param),
          defaultValue: (defaultValue === undefined) ? null : defaultValue,
          callbackOnChange: onChange,
          /**
           * Given a parameter definition (as built by `#addParam`), get its URL
           * value or, if `undefined`, the default value.
           *
           * @returns {*}
           */
          getUrlValueOrDefault: function () {
            var urlParams = devex.urls.getParams();
            var value = extractValueFromUrl(this.param, urlParams);
            return (value === undefined) ? _.clone(this.defaultValue) : value;
          }
        };
        definedParams.push(paramDefinition);

        // initialize parameter with value from URL
        paramDefinition.callbackOnChange(
          paramDefinition.getUrlValueOrDefault()
        );

        return paramDefinition.identifier;
      },
      /**
       * Removes all defined parameters
       */
      resetDefinedParams: function() {
        definedParams = [];
      },
      /**
       * Update the parameters in the URL based on the current values of the
       * defined parameters.
       *
       * First, removes all parameters from the URL, then iterates over all
       * defined parameters and if they are different from their default value,
       * adds them to the URL params.
       */
      updateUrl: function() {
        var paramsStringUrl = '?';
        var anyParamAdded = false;

        definedParams.forEach(function(definedParam) {
          if (!_.isEqual(definedParam.getValue(), definedParam.defaultValue)) {
            if (anyParamAdded) {
              paramsStringUrl += '&';
            }
            paramsStringUrl += $.param(generateParamValue(definedParam.param)).replace(/'/g, '%27');
            anyParamAdded = true;
          }
        });
        paramsStringUrl = anyParamAdded ? paramsStringUrl : '';
        if (devex.urls.getLocation().search === paramsStringUrl) {
          return; // No changes to URL params
        }

        if (paramsStringUrl === '') {
          // `history.pushState` with empty string does not change the URL, nor
          // removes the search params. Therefore, pass the path without any
          // params, which then removes the search of the URL
          devex.urls.pushState(
            null, document.title, document.location.pathname
          );
        } else {
          devex.urls.pushState(null, document.title, paramsStringUrl);
        }
      },
      /**
       * Register to an event on specific parameters.
       * Available events:
       *  - `afterParametersChanged`: Triggered after any of the parameters
       *                              passed via `parameterIdentifiers` have
       *                              changed their value
       * @param {string} event, currently only `afterParametersChanged` is
       *                 supported
       * @param {string[]} parameterIdentifiers
       * @param {function} callback
       * @returns {boolean} True if callback was successfully registered
       */
      on: function(event, parameterIdentifiers, callback) {
        if (event === 'afterParametersChanged') {
          return registerAfterParamsChangedCallback(parameterIdentifiers, callback);
        } else {
          console.warn('`' + event + '` is no supported event');
          return false;
        }
      }
    };
  }
  return {
    /**
     * The BrowserUrl handler is a singleton object, use this method to get the
     * instance or instantiate it if it was not initialized before.
     * @returns {devex.urls.BrowserUrl}
     */
    getInstance: function() {
      if (!instance) {
        instance = init();
      }
      return instance;
    }
  };
})();
